"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.GroupEditFeaturedTopicsModal = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _modal = _interopRequireWildcard(require("@insided/deprecated-preact-components/design-system-components/modal"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _InputGroup = _interopRequireDefault(require("@insided/shared/uikit/InputGroup"));

var _Navigation = require("@insided/destination/modules/Navigation");

var _service = require("./service");

var _classnames = _interopRequireDefault(require("classnames"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var GroupEditFeaturedTopicsModal = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(GroupEditFeaturedTopicsModal, _Component);

  var _super = _createSuper(GroupEditFeaturedTopicsModal);

  function GroupEditFeaturedTopicsModal() {
    var _this;

    (0, _classCallCheck2.default)(this, GroupEditFeaturedTopicsModal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      featuredTopics: _this.props.featuredTopics || [],
      title: _this.props.title || ''
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setFeaturedTopics", function (value) {
      _this.setState({
        featuredTopics: value
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setFeaturedTopicsTitle", function (value) {
      _this.setState({
        title: value
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "saveTopics", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var _this$state, featuredTopics, title, curatedTopics;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$state = _this.state, featuredTopics = _this$state.featuredTopics, title = _this$state.title;
              curatedTopics = featuredTopics.map(function (topic) {
                return {
                  id: topic.id,
                  type: topic.contentType
                };
              });
              _context.next = 4;
              return (0, _service.saveFeaturedTopics)({
                groupId: _this.props.groupId,
                data: {
                  contentCuration: {
                    curatedTopics: curatedTopics,
                    title: title
                  }
                }
              });

            case 4:
              _this.props.onClose();

              if (typeof window !== 'undefined') {
                window.location.reload();
              }

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    return _this;
  }

  (0, _createClass2.default)(GroupEditFeaturedTopicsModal, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state2 = this.state,
          title = _this$state2.title,
          featuredTopics = _this$state2.featuredTopics;
      var onClose = this.props.onClose;
      return (0, _preact.h)(_modal.default, {
        onClose: onClose,
        customClass: "groups-edit-featured-topics-modal-wrapper"
      }, (0, _preact.h)(_modal.ModalHeader, {
        title: (0, _preact.h)(_phrase.default, {
          p: "groups.edit.featured.content"
        })
      }), (0, _preact.h)(_modal.ModalBody, null, (0, _preact.h)("div", {
        className: "groups-edit-featured-topics-modal"
      }, (0, _preact.h)(_InputGroup.default, {
        title: (0, _preact.h)(_phrase.default, {
          p: "groups.section.title"
        }),
        newStyle: true,
        placeholder: "Featured Topics Title",
        type: "text",
        onChange: function onChange(e) {
          _this2.setFeaturedTopicsTitle(e.target.value);
        },
        value: title,
        formGroupClasses: "groups-edit-featured-topics-modal_title",
        required: true,
        hasError: !title,
        error: !title ? 'Please enter a Featured Topics Title' : ''
      }), (0, _preact.h)("div", {
        className: "groups-edit-featured-topics-modal_description"
      }, (0, _preact.h)(_phrase.default, {
        p: "groups.edit.topics.description"
      })), (0, _preact.h)(_Navigation.FeaturedTopicsManager, {
        newStyle: true,
        newStyleTopic: true,
        searchPlaceholder: "Type to search for topic or paste URL",
        onUpdate: function onUpdate(_, value) {
          return _this2.setFeaturedTopics(value);
        },
        featuredTopics: featuredTopics
      }))), (0, _preact.h)(_modal.ModalFooter, null, (0, _preact.h)(_Button.default, {
        size: "medium",
        className: "groups-edit-featured-topics-modal_cancel-btn",
        onClick: onClose
      }, (0, _preact.h)(_phrase.default, {
        p: "groups.cancel"
      })), (0, _preact.h)(_Button.default, {
        size: "medium",
        className: (0, _classnames.default)('groups-edit-featured-topics-modal_save-btn', {
          'is-disabled': !title
        }),
        onClick: this.saveTopics,
        "data-bounded-context": "Groups",
        "data-entity": "featured-topics-edit",
        "data-track-type": "click",
        "data-element-name": "Featured Topics Update",
        disabled: !title
      }, (0, _preact.h)(_phrase.default, {
        p: "groups.save"
      }))));
    }
  }]);
  return GroupEditFeaturedTopicsModal;
}(_preact.Component);

exports.GroupEditFeaturedTopicsModal = GroupEditFeaturedTopicsModal;
var _default = GroupEditFeaturedTopicsModal;
exports.default = _default;